export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

/**
 * Get full URL for uploaded files (images, logos, etc.)
 * Handles both relative paths (/uploads/...) and absolute URLs
 */
export const getImageUrl = (path) => {
  if (!path) return '';
  // If already a full URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Prepend API URL for relative paths
  const apiUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${apiUrl}${path}`;
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'DRAFT':
      return 'bg-gray-100 text-gray-800';
    case 'SENT':
      return 'bg-blue-100 text-blue-800';
    case 'CONFIRMED':
      return 'bg-green-100 text-green-800';
    case 'CANCELLED':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getMealPlanLabel = (plan) => {
  const labels = {
    CP: 'Breakfast Only',
    MAP: 'Breakfast + Dinner',
    AP: 'All Meals',
    EP: 'Room Only',
  };
  return labels[plan] || plan;
};

export const getRoomCategoryLabel = (category) => {
  return category.replace(/_/g, ' ');
};